import React, { useEffect, useState } from "react";
import { FaRegImage } from "react-icons/fa";
import AddBrand from "../modals/equipment-modal/add-brand";
import { getEquipmentBrand, deleteEquipmentBrand } from "../../api";
import config from "../../config";
import { confirmAlert } from "react-confirm-alert";
import Pagination from "../common/Pagination";

const STRATUS_URL = config.paymentcloud.STRATUS_URL;

export default function Brands() {
    const [addBrandModal, setAddBrandModal] = useState(false);
    const [brands, setBrands] = useState([]);
    const [activeBrand, setActiveBrand] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalBrands, setTotalBrands] = useState(0);

    useEffect(() => {
        getData();
    }, [searchValue]);

    const getData = (page = 1) => {
        getEquipmentBrand({
            search_keyword: searchValue,
            page,
        })
            .then((res) => {
                if (res.status) {
                    setBrands(res.data.data);
                    setCurrentPage(res.data.current_page);
                    setTotalBrands(res.data.total);
                }
            })
            .catch((err) => {});
    };

    const deleteBrand = (brand) => {
        confirmAlert({
            title: "Delete Brad",
            message: "Are you sure you want to delete the Brand?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        deleteEquipmentBrand(brand)
                            .then((res) => {
                                getData();
                            })
                            .catch((err) => {});
                    },
                },
                {
                    label: "No",
                },
            ],
        });
    };

    return (
        <>
            <div className="panel-heading" id="pannel-headingId">
                <div className="d-flex">
                    <h4>
                        Equipment Brand<span>({totalBrands})</span>
                    </h4>
                    <button
                        className="orgbtn"
                        onClick={() => setAddBrandModal(true)}
                    >
                        <i className="fa fa-create"></i> Add Brand
                    </button>
                </div>
                <div className="header-search">
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                        }}
                    >
                        <input
                            type="text"
                            placeholder="Search"
                            name="search"
                            onChange={(e) => setSearchValue(e.target.value)}
                            className="search-box"
                        />
                        <button type="button">
                            {" "}
                            <i className="fa fa-search"></i>{" "}
                        </button>
                    </form>
                </div>
            </div>

            <div
                className="table-organizations table-templates mcc-table"
                style={{ marginBottom: "6rem" }}
            >
                <table
                    className="table table-striped table-responsive template-list"
                    id="template-index-table"
                >
                    <thead>
                        <tr>
                            <th>
                                <FaRegImage size={20} />
                            </th>
                            <th className="TemplateTitle">Equiment Brand</th>
                            <th className="TemplateTitle">Description</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {brands.map((brand) => (
                            <tr>
                                <td className="">
                                    <img
                                        src={`${STRATUS_URL}get-image-by-path?path=${brand.image}`}
                                        style={{
                                            width: "50px",
                                            height: "50px",
                                            border: "1px solid #cecece",
                                            borderRadius: "50%",
                                        }}
                                    />
                                </td>
                                <td className="">
                                    <div className="org-full-name">
                                        <h4>{brand.name}</h4>
                                    </div>
                                </td>
                                <td className="">
                                    <div className="org-full-name">
                                        <p>{brand.description}</p>
                                    </div>
                                </td>
                                <td className="addresidual template-add-delete">
                                    <span
                                        onClick={() => {
                                            setActiveBrand(brand);
                                            setAddBrandModal(true);
                                        }}
                                    >
                                        Edit
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pagination
                    onPageChange={getData}
                    itemsCount={totalBrands}
                    page={currentPage}
                    itemsPerPage={10}
                />
            </div>

            {/* Modals */}
            {addBrandModal && (
                <AddBrand
                    open={addBrandModal}
                    close={() => {
                        setAddBrandModal(false);
                        getData();
                    }}
                    activeBrand={activeBrand}
                    isEdit={activeBrand !== null ? true : false}
                />
            )}
        </>
    );
}
